<template>
  <treeselect
    v-model="property"
    class="form-input-select"
    :options="options"
    :load-options="loadOptions"
    :normalizer="listElementNormalizer"
    :placeholder="$tc(placeholder, 1)"
    :disabled="disabled"
    disableFuzzyMatching
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { mapActions } from "vuex";

export default {
  name: "DuctEntryFormCableSelectionTreeselect",

  mixins: [listsMixin],

  props: {
    cable: {
      type: Object,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      typeOptions: null,
      operatorOptions: null,
      property: null
    };
  },

  mounted() {
    this.property =
      this.placeholder === "Operator"
        ? this.cable.mdec_operator
        : this.cable.mdec_type;
  },

  computed: {
    disabled() {
      return this.$store.getters.isManholeMasksTabDisabled;
    },

    options() {
      return this.placeholder === "Operator"
        ? this.operatorOptions
        : this.typeOptions;
    }
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    async loadOptions() {
      if (this.placeholder === "Operator") {
        let listName = "list_operators";
        this.operatorOptions = this.$store.getters.getListOfOptionsByListName(
          listName,
          [this.cable.mdec_operator]
        );
        if (this.operatorOptions === undefined) {
          this.operatorOptions = await this.GET_LIST({
            listName: listName,
            code: [this.cable.mdec_operator]
          });
        }
      } else if (this.placeholder === "Type") {
        let listName = "list_duct_entry_cable_type";
        this.typeOptions = this.$store.getters.getListOfOptionsByListName(
          listName,
          [this.cable.mdec_type]
        );
        if (this.typeOptions === undefined) {
          this.typeOptions = await this.GET_LIST({
            listName: listName,
            code: [this.cable.mdec_operator]
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryFormCableSelectionTreeselect.vue